export const NO_TABLE_DATA_TEXT = 'No results found. Data not available.';
export const NO_FILTERS_DATA_TABLE_TEXT =
  'No results found. Please try and adjust filters.';
